/** Arabic for text inside the generated dashboard boards, applied by i18n/dom.ts (batch 1). Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "Standby generators": "مولدات الطاقة الاحتياطية",
  "ACKNOWLEDGE ALL": "الإقرار بالكل",
  Facilities: "المرافق",
  "Safety and compliance": "السلامة والامتثال",
  Business: "الأعمال",
  "Instrument style": "نمط المؤشرات",
  CARD: "بطاقات",
  LIST: "قائمة",
  Order: "الترتيب",
  CRITICALITY: "الأهمية",
  ARRANGE: "ترتيب",
  CUSTOMISE: "تخصيص",
  "DEMO FEEDS": "مصادر تجريبية",
  "SKY LOGICS OPERATIONS CENTER": "مركز عمليات SKY LOGICS",
  "Needs attention — click for the source and the method.": "يحتاج إلى متابعة — انقر لمعرفة المصدر والطريقة.",
  outside: "خارج الحدود",
  "WHERE THIS COMES FROM →": "مصدر هذه البيانات ←",
  "Madinah · Kingdom of Saudi Arabia": "المدينة المنورة · المملكة العربية السعودية",
  "ACTION REQUIRED": "مطلوب إجراء",
  "Outside limits: Standby generators.": "خارج الحدود: مولدات الطاقة الاحتياطية.",
  "OPEN WORK": "أعمال مفتوحة",
  "OPEN FINDINGS": "ملاحظات مفتوحة",
  "Resolved and holding": "ما تمت معالجته ولا يزال ثابتاً",
  closed: "مغلق",
  "Work orders completed": "أوامر العمل المكتملة",
  "Findings closed": "الملاحظات المغلقة",
  "Incidents closed": "الحوادث المغلقة",
  "Inspections accepted": "الفحوص المقبولة",
  "Alarms acknowledged": "الإنذارات المُقرّ بها",
  "Median days to close": "متوسط أيام الإغلاق",
  "Still open": "لا يزال مفتوحاً",
  "Capacity and demand": "السعة والطلب",
  "how close the airport is running to what it is declared to handle": "مدى اقتراب تشغيل المطار من السعة المعلنة له",
  "Airport capacity": "سعة المطار",
  "movements not fed": "حركات غير متصلة بمصدر",
  "■ arrivals": "■ القدوم",
  "■ departures": "■ المغادرة",
  "Declared hourly movements, terminal design capacity and the stand count come from the aerodrome manual and the slot file. Connect them and this reads utilisation against what the aerodrome is actually declared to handle.":
    "تأتي الحركات المعلنة في الساعة والسعة التصميمية لمبنى الركاب وعدد مواقف الطائرات من دليل المطار وملف الفترات الزمنية. اربطها ليُحسب الاستخدام مقابل ما أُعلن فعلاً أن المطار يستوعبه.",
  "Passengers year to date": "الركاب منذ بداية العام",
  MONTHS: "الأشهر",
  PACE: "الوتيرة",
  "■ this year": "■ هذا العام",
  "▢ forecast": "▢ متوقع",
  "Passenger numbers come from the AODB or the monthly reconciliation.":
    "تأتي أعداد الركاب من AODB أو من المطابقة الشهرية.",
  "Live picture": "الصورة المباشرة",
  "section readiness, the scope, and twelve weeks of work": "جاهزية الأقسام والنطاق واثنا عشر أسبوعاً من العمل",
  "Systems readiness": "جاهزية الأنظمة",
  "Each column averages that section's indicators against the same limits the meters use. Tap for the breakdown.":
    "كل عمود هو متوسط مؤشرات ذلك القسم مقابل الحدود نفسها التي تستخدمها المقاييس. انقر للتفاصيل.",
  "Systems scope": "نطاق الأنظمة",
  "Range rings are the sections and blips are indicators — layout, not geography. Tap for the track list.":
    "الحلقات هي الأقسام والنقاط هي المؤشرات — ترتيب للعرض وليس موقعاً جغرافياً. انقر لقائمة المسارات.",
  "Airport facilities readiness": "جاهزية مرافق المطار",
  "Terminal, check-in, immigration, screening, customs and the gates, each from the indicator that measures it. Tap for the breakdown.":
    "مبنى الركاب وإنهاء إجراءات السفر والجوازات والتفتيش الأمني والجمارك والبوابات، كلٌّ من المؤشر الذي يقيسه. انقر للتفاصيل.",
  "Security and threats": "الأمن والتهديدات",
  "Airside readiness": "جاهزية الجانب الجوي",
  "READY WITH EXCEPTIONS": "جاهز مع استثناءات",
  "Access control breaches": "اختراقات التحكم في الدخول",
  "door, gate and pass status awaiting feed": "حالة الأبواب والبوابات والتصاريح بانتظار المصدر",
  "Door and gate status, breach events and pass currency come from the access control system. Work orders on doors, gates, readers and barriers are already held here.":
    "تأتي حالة الأبواب والبوابات وأحداث الاختراق وصلاحية التصاريح من نظام التحكم في الدخول. أوامر العمل على الأبواب والبوابات والقارئات والحواجز محفوظة هنا بالفعل.",
  "Runway incursions": "توغلات المدرج",
  "none reported": "لم يُبلَّغ عن شيء",
  "Foreign object debris": "الأجسام الغريبة",
  "Runways and taxiways readiness": "جاهزية المدرجات وممرات الطائرات",
  "Airspace status": "حالة المجال الجوي",
  "airspace status awaiting feed": "حالة المجال الجوي بانتظار المصدر",
  "Incident reports · all sections": "بلاغات الحوادث · جميع الأقسام",
  "REPORT AN INCIDENT": "الإبلاغ عن حادث",
  "serious open": "خطيرة مفتوحة",
  significant: "كبيرة",
  minor: "بسيطة",
  "Nothing reported here. An empty register is only good news if people are reporting.":
    "لا توجد بلاغات هنا. السجل الفارغ خبر جيد فقط إذا كان الناس يبلّغون.",
  "Systems Intelligence & Analysis": "ذكاء الأنظمة وتحليلها",
  "anomaly detection, reliability modelling and failure forecasting across every system on the airport":
    "كشف الشذوذ ونمذجة الموثوقية والتنبؤ بالأعطال في جميع أنظمة المطار",
  Friction: "الاحتكاك",
  "→ Run the post-removal verification survey.": "← أجرِ مسح التحقق بعد الإزالة.",
  "Acknowledge the risk and hide this. The condition itself does not change.":
    "أقرّ بالمخاطرة وأخفِ هذا. الحالة نفسها لا تتغير.",
  "Low friction away from any touchdown zone": "احتكاك منخفض بعيداً عن أي منطقة ملامسة",
  Anomaly: "شذوذ",
  "→ Texture depth will separate flushing from braking deposits.": "← عمق النسيج السطحي يميّز بين الغسل ورواسب الكبح.",
  "Removal carried out with a surface defect open": "إزالة نُفذت مع وجود عيب مفتوح في السطح",
  "Ravelling was reported and a removal has been run, but the method and settings are not on record.":
    "أُبلغ عن تفكك السطح ونُفذت إزالة، لكن الطريقة والإعدادات غير مسجلة.",
  "→ Confirm the method used and inspect the treated area for aggregate pluck-out.":
    "← أكّد الطريقة المستخدمة وافحص المنطقة المعالجة بحثاً عن اقتلاع الركام.",
  "Generator test currency is out of date": "اختبار المولدات لم يعد سارياً",
  "Standby power": "الطاقة الاحتياطية",
  "→ A generator that has not been load tested is an assumption, not a backup.":
    "← المولد الذي لم يُختبر تحت الحمل افتراض وليس احتياطاً.",
  Incursions: "التوغلات",
  "Loose aggregate reported with no sweeper log": "ركام سائب مُبلَّغ عنه دون سجل للكنس",
  "Ravelling was reported in a touchdown zone and no sweeper runs are recorded for today.":
    "أُبلغ عن تفكك السطح في منطقة ملامسة ولا توجد عمليات كنس مسجلة اليوم.",
  "→ Sweep and log until the surface is repaired.": "← اكنس وسجّل حتى يُصلَح السطح.",
  "No inspection filed for airfield, terminal, landside": "لا يوجد فحص مسجل للجانب الجوي ومبنى الركاب والجانب الأرضي",
  "Certification readiness cannot be scored for a domain with no detailed inspection.":
    "لا يمكن تقييم جاهزية الاعتماد لمجال لم يُجرَ له فحص تفصيلي.",
  "→ Run one detailed sweep per domain to set the baseline.": "← أجرِ جولة تفصيلية واحدة لكل مجال لتحديد خط الأساس.",
  "Data quality": "جودة البيانات",
  "AGL units and signs laid out from the runway geometry at standard spacings.":
    "وحدات AGL واللوحات موزعة من هندسة المدرج بالتباعد القياسي.",
  "→ Replace with the AGL as-built or correct them as crews work each unit.":
    "← استبدلها بمخططات AGL المنفذة أو صحّحها كلما عملت الفرق على كل وحدة.",
  "Nothing is in the no-go band": "لا شيء في نطاق غير صالح",
  "→ The cautions below are what to work through.": "← التحذيرات أدناه هي ما يجب العمل عليه.",
  "TEN SHOWN · SCROLL FOR THE REST · CRITICAL FIRST": "عشرة معروضة · مرّر لرؤية البقية · الحرجة أولاً",
  "What the model would do about it": "ما سيفعله النموذج حيال ذلك",
  "Runway and taxiway pavement": "رصف المدرجات وممرات الطائرات",
  "Inspect and plan intervention now": "افحص وخطط للتدخل الآن",
  "Condition monitor, keep spares": "راقب الحالة واحتفظ بقطع الغيار",
  "Boarding bridges": "جسور صعود الركاب",
  "Run and inspect": "شغّل وافحص",
  "Lifts and escalators": "المصاعد والسلالم المتحركة",
  "Cooling and air handling": "التبريد ومناولة الهواء",
  "Baggage handling": "مناولة الأمتعة",
  "Screening equipment": "أجهزة التفتيش الأمني",
  "Switchgear and transformers": "لوحات المفاتيح والمحولات",
  "Docking guidance": "أنظمة توجيه الالتحام",
  "Point at any figure": "أشر إلى أي رقم",
  "click the row": "انقر الصف",
  "Predicted attention": "المتابعة المتوقعة",
  "HOW THIS WAS SCORED": "طريقة التقييم",
  "past its interval": "تجاوز فترته",
  "recent failures": "أعطال حديثة",
  "findings still open": "ملاحظات لا تزال مفتوحة",
  "Failure risk, next ninety days": "مخاطر الأعطال، التسعون يوماً القادمة",
  "What the failures will cost, next ninety days": "تكلفة الأعطال، التسعون يوماً القادمة",
  "Cost basis": "أساس التكلفة",
  Difference: "الفرق",
  Annualised: "سنوياً",
  PARTS: "قطع الغيار",
  DISRUPTION: "التعطّل",
  "localised repair, night possession": "إصلاح موضعي، إغلاق ليلي",
  assumed: "مفترض",
  "fitting, lamp and re-aim": "تركيبة ومصباح وإعادة توجيه",
  "drive or control replacement": "استبدال المحرك أو وحدة التحكم",
  "platform default": "الافتراضي في المنصة",
  "injector, control card or battery": "حاقن أو بطاقة تحكم أو بطارية",
  "compressor or AHU component": "ضاغط أو مكوّن وحدة مناولة الهواء",
  "belt, motor or sensor": "سير أو محرك أو حساس",
  "Faults by month, by class": "الأعطال حسب الشهر والفئة",
  "Service life used": "العمر التشغيلي المستهلك",
  "Twelve week work trend": "اتجاه العمل على اثني عشر أسبوعاً",
  "■ raised": "■ مُنشأ",
  "■ closed": "■ مغلق",
  "■ findings": "■ ملاحظات",
  "■ ahead of last year": "■ متقدم على العام الماضي",
  "■ behind": "■ متأخر",
  "▢ forecast month": "▢ شهر متوقع",
  "Airport Facilities": "مرافق المطار",
  "Airfield Inspections": "فحوص الجانب الجوي",
  Systems: "الأنظمة",
  "three areas — the movement area, the buildings on it, and everything outside the fence. Every asset, work order and certificate in the platform belongs to one of them.":
    "ثلاث مناطق — منطقة الحركة، والمباني عليها، وكل ما هو خارج السياج. كل أصل وأمر عمل وشهادة في المنصة ينتمي إلى إحداها.",
  "OPEN THE PAGE": "فتح الصفحة",
  PROGRAMMES: "البرامج",
  "PAST CYCLE": "الدورة السابقة",
  "OPEN FULL SCREEN": "فتح بملء الشاشة",
  FACILITIES: "المرافق",
  PLANS: "المخططات",
  "Everything outside the fence: roads, forecourt, car parks, footways, lighting and the boundary itself.":
    "كل ما هو خارج السياج: الطرق والساحة الأمامية ومواقف السيارات والممرات والإنارة والحدود نفسها.",
  AREAS: "المناطق",
  ROUNDS: "الجولات",
  "What sits under each area": "ما يندرج تحت كل منطقة",
  Plans: "المخططات",
  "Friction → ENGINEERING": "الاحتكاك ← الهندسة",
  "Rubber contamination → ENGINEERING": "التلوث بالمطاط ← الهندسة",
  LEVELS: "الطوابق",
  ZONES: "النطاقات",
  "Roads, kerbside, car parks and the approaches — the part of the airport most passengers meet first and the platform usually forgets.":
    "الطرق والأرصفة ومواقف السيارات والمداخل — الجزء من المطار الذي يلقاه معظم الركاب أولاً وتغفله المنصات عادة.",
  "WALK A ROUND": "ابدأ جولة",
  "never walked": "لم تُجرَ جولة",
  "Aprons and stands": "ساحات ومواقف الطائرات",
  "RESA and strips": "RESA والأشرطة",
  "Shoulders and infields": "الأكتاف والمناطق الداخلية",
  "Service roads and gates": "طرق الخدمة والبوابات",
  "Perimeter and fence line": "المحيط وخط السياج",
  "RFF access and stations": "مداخل ومحطات RFF",
  "Fuel farm and hydrants": "مستودع الوقود وشبكة الإمداد",
  "No round has been walked. An area with no round against it reads as never walked rather than as clear.":
    "لم تُجرَ أي جولة. المنطقة التي لا جولة عليها تظهر بأنها لم تُفحص وليس بأنها سليمة.",
  "Buildings inspections": "فحوص المباني",
  "Departures hall": "صالة المغادرة",
  "Arrivals hall": "صالة القدوم",
  "Gates and holdrooms": "البوابات وصالات الانتظار",
  "Baggage hall": "صالة الأمتعة",
  "Offices and back of house": "المكاتب والمناطق الخلفية",
  "Plant rooms": "غرف المعدات",
  Washrooms: "دورات المياه",
  "Roof and facade": "السطح والواجهة",
  "Multi-storey car park": "موقف السيارات متعدد الطوابق",
  "Landside inspections": "فحوص الجانب الأرضي",
  "Terminal forecourt": "الساحة الأمامية لمبنى الركاب",
  "Access roads": "طرق الوصول",
  "Car parks": "مواقف السيارات",
  "Taxi and bus ranks": "مواقف سيارات الأجرة والحافلات",
  "Footways and crossings": "الممرات والمعابر",
  "Road lighting": "إنارة الطرق",
  "Drainage and gullies": "التصريف والمصارف",
  "Boundary and fencing": "الحدود والأسوار",
  "Road signage": "اللوحات المرورية",
  "Barriers and control": "الحواجز والتحكم",
  "Pavement condition": "حالة الرصف",
  "never inspected": "لم يُفحص",
  "Shoulders and infields levelling": "تسوية الأكتاف والمناطق الداخلية",
  "RESA and strip": "RESA والشريط",
  "Vertical signage": "اللوحات الإرشادية الرأسية",
  Drainage: "التصريف",
  Vegetation: "الغطاء النباتي",
  Wildlife: "الحياة الفطرية",
  "Perimeter fencing": "السياج المحيطي",
  "Wind sock": "كم الرياح",
  "General safety": "السلامة العامة",
  "No round has been walked. Every topic reads as never inspected, which is what it is — the platform will not show an unwalked airfield as clear.":
    "لم تُجرَ أي جولة. كل موضوع يظهر بأنه لم يُفحص، وهذا هو واقعه — المنصة لن تُظهر مطاراً لم تُجرَ عليه جولة على أنه سليم.",
  "condition of the airport's own assets": "حالة أصول المطار",
  "condition of the airport's own assets and records": "حالة أصول المطار وسجلاته",
  "Runways and taxiways": "المدرجات وممرات الطائرات",
  "Ravelling and Aggregate loss reported in the touchdown zone; extent not yet surveyed.":
    "تفكك السطح وفقد الركام مُبلَّغ عنهما في منطقة ملامسة الأرض؛ لم يُمسح الامتداد بعد.",
  "Inventory is derived from the runway geometry, not an as-built. No findings, but nothing verified either.":
    "المخزون مستنتج من هندسة المدرج وليس من المخططات المنفذة. لا ملاحظات، ولكن لم يُتحقق من شيء أيضاً.",
  "One sign generated per surveyed holding position. Positions and legends need field confirmation.":
    "لوحة واحدة مُنشأة لكل موقع انتظار تم مسحه. المواقع والنصوص تحتاج إلى تأكيد ميداني.",
  "Buildings and infrastructure": "المباني والبنية التحتية",
  "Records and evidence": "السجلات والأدلة",
  "Ground utilities": "المرافق الأرضية",
  "No inspection has been filed for this domain.": "لم يُسجَّل أي فحص لهذا المجال.",
  "Terminal inspections": "فحوص مبنى الركاب",
  "Access gates and control": "بوابات الدخول والتحكم",
  "Air traffic control tower": "برج المراقبة الجوية",
  "Navaids and met": "المساعدات الملاحية والأرصاد",
  "Nothing outstanding.": "لا شيء معلق.",
  "Critical utilities": "المرافق الحيوية",
  "TODAY'S ROUND": "جولة اليوم",
  "Power supply and backup": "الإمداد بالطاقة والاحتياط",
  "NEVER CHECKED": "لم يُفحص قط",
  "Generator start test — not done": "اختبار تشغيل المولد — لم يُنفذ",
  "Generator fuel level — not done": "مستوى وقود المولد — لم يُنفذ",
  "UPS battery health — not done": "سلامة بطاريات UPS — لم يُنفذ",
  "UPS load — not done": "حمل UPS — لم يُنفذ",
  "Dual supply to critical loads — not done": "الإمداد المزدوج للأحمال الحرجة — لم يُنفذ",
  "AGL constant current regulators — not done": "منظمات التيار الثابت لـ AGL — لم يُنفذ",
  "never checked": "لم يُفحص قط",
  "failure likelihood, ninety days · thin confidence": "احتمال العطل، تسعون يوماً · ثقة ضعيفة",
  "Fuel farm and hydrant system": "مستودع الوقود وشبكة الإمداد",
  "Water draining — not done": "تصريف الماء — لم يُنفذ",
  "Filter differential pressure — not done": "فرق ضغط المرشحات — لم يُنفذ",
  "Emergency shut-off — not done": "الإيقاف الطارئ — لم يُنفذ",
  "Hydrant pit valves — not done": "صمامات حفر الإمداد — لم يُنفذ",
  "Bonding and earthing — not done": "الربط والتأريض — لم يُنفذ",
  "Cooling and HVAC": "التبريد والتكييف",
  "Chillers running — not done": "تشغيل المبردات — لم يُنفذ",
  "Server room temperature — not done": "حرارة غرفة الخوادم — لم يُنفذ",
  "Terminal temperature — not done": "حرارة مبنى الركاب — لم يُنفذ",
  "Server room humidity — not done": "رطوبة غرفة الخوادم — لم يُنفذ",
  "AHU filters — not done": "مرشحات وحدات مناولة الهواء — لم يُنفذ",
  "Condenser water — not done": "مياه المكثفات — لم يُنفذ",
  "Water and sewage": "المياه والصرف الصحي",
  "Potable storage — not done": "خزانات مياه الشرب — لم يُنفذ",
  "Distribution pressure — not done": "ضغط التوزيع — لم يُنفذ",
  "Residual chlorine — not done": "الكلور المتبقي — لم يُنفذ",
  "Sewage lift stations — not done": "محطات رفع الصرف الصحي — لم يُنفذ",
  "Treatment plant — not done": "محطة المعالجة — لم يُنفذ",
  "Lavatory servicing point — not done": "نقطة خدمة دورات مياه الطائرات — لم يُنفذ",
  "IT network and cyber security": "شبكة تقنية المعلومات والأمن السيبراني",
  "Core switches and firewalls — not done": "المبدلات الرئيسية والجدران النارية — لم يُنفذ",
  "Internet and WAN — not done": "الإنترنت والشبكة الواسعة — لم يُنفذ",
  "Backups — not done": "النسخ الاحتياطية — لم يُنفذ",
  "Patching — not done": "التحديثات الأمنية — لم يُنفذ",
  "Operational network segregation — not done": "فصل الشبكة التشغيلية — لم يُنفذ",
  "Security events — not done": "الأحداث الأمنية — لم يُنفذ",
  "Fire detection and suppression": "كشف الحريق وإخماده",
  "Fire alarm panel — not done": "لوحة إنذار الحريق — لم يُنفذ",
  "Fire pumps — not done": "مضخات الحريق — لم يُنفذ",
  "Fire water storage — not done": "خزانات مياه الحريق — لم يُنفذ",
  "Special hazard suppression — not done": "إخماد المخاطر الخاصة — لم يُنفذ",
  "Detection heads — not done": "رؤوس الكشف — لم يُنفذ",
  "Portable extinguishers — not done": "الطفايات المحمولة — لم يُنفذ",
  "AODB and RMS — airport operations core": "AODB وRMS — نواة عمليات المطار",
  "AODB availability — not done": "توفر AODB — لم يُنفذ",
  "Flight schedule synchronised — not done": "مزامنة جدول الرحلات — لم يُنفذ",
  "Interface queues — not done": "طوابير الواجهات — لم يُنفذ",
  "Resource allocation conflicts — not done": "تعارضات تخصيص الموارد — لم يُنفذ",
  "Response time — not done": "زمن الاستجابة — لم يُنفذ",
  "Backup and restore — not done": "النسخ الاحتياطي والاستعادة — لم يُنفذ",
  "Data quality — not done": "جودة البيانات — لم يُنفذ",
  "Power supply and IT network backbone": "الإمداد بالطاقة والعمود الفقري لشبكة تقنية المعلومات",
  "Feeder diversity — not done": "تنوع المغذيات — لم يُنفذ",
  "Fibre ring integrity — not done": "سلامة حلقة الألياف — لم يُنفذ",
  "Comms room power — not done": "طاقة غرف الاتصالات — لم يُنفذ",
  "Comms room cooling — not done": "تبريد غرف الاتصالات — لم يُنفذ",
  "Redundant path test — not done": "اختبار المسار البديل — لم يُنفذ",
  "Single points of failure — not done": "نقاط الفشل المنفردة — لم يُنفذ",
  "Earthing and surge protection — not done": "التأريض والحماية من التيار المفاجئ — لم يُنفذ",
  "CUPPS and CUTE — common use check-in and boarding": "CUPPS وCUTE — إنهاء الإجراءات والصعود المشترك",
  "Platform servers — not done": "خوادم المنصة — لم يُنفذ",
  "Check-in workstations — not done": "محطات إنهاء الإجراءات — لم يُنفذ",
  "Boarding pass and bag tag printers — not done": "طابعات بطاقات الصعود وملصقات الأمتعة — لم يُنفذ",
  "Gate readers — not done": "قارئات البوابات — لم يُنفذ",
  "Airline applications — not done": "تطبيقات شركات الطيران — لم يُنفذ",
  "Consumables — not done": "المستهلكات — لم يُنفذ",
  "Baggage handling system": "نظام مناولة الأمتعة",
  "Lines available — not done": "الخطوط المتاحة — لم يُنفذ",
  "Jams overnight — not done": "الانحشارات خلال الليل — لم يُنفذ",
  "Sortation accuracy — not done": "دقة الفرز — لم يُنفذ",
  "Mishandled bags — not done": "الأمتعة التي أسيئت مناولتها — لم يُنفذ",
  "Screening integration — not done": "التكامل مع التفتيش — لم يُنفذ",
  "Emergency stops and guards — not done": "التوقف الطارئ والواقيات — لم يُنفذ",
  "Hold baggage screening": "تفتيش الأمتعة المسجلة",
  "Machines available — not done": "الأجهزة المتاحة — لم يُنفذ",
  "Calibration and daily test — not done": "المعايرة والاختبار اليومي — لم يُنفذ",
  "Standard in use — not done": "المعيار المستخدم — لم يُنفذ",
  "Alarm resolution rate — not done": "معدل حل الإنذارات — لم يُنفذ",
  "Reconciliation — not done": "المطابقة — لم يُنفذ",
  "Screener certification — not done": "اعتماد موظفي التفتيش — لم يُنفذ",
  "Security screening systems": "أنظمة التفتيش الأمني",
  "Lanes open — not done": "المسارات المفتوحة — لم يُنفذ",
  "X-ray daily test — not done": "الاختبار اليومي لأجهزة الأشعة — لم يُنفذ",
  "Body scanners — not done": "الماسحات الجسدية — لم يُنفذ",
  "Explosive trace detection — not done": "كشف آثار المتفجرات — لم يُنفذ",
  "Queue time — not done": "زمن الانتظار — لم يُنفذ",
  "Access control and CCTV": "التحكم في الدخول وكاميرات المراقبة",
  "Doors and readers — not done": "الأبواب والقارئات — لم يُنفذ",
  "Forced and held-open alarms — not done": "إنذارات الفتح القسري والإبقاء مفتوحاً — لم يُنفذ",
  "Pass system — not done": "نظام التصاريح — لم يُنفذ",
  "Cameras in service — not done": "الكاميرات العاملة — لم يُنفذ",
  "Recording and retention — not done": "التسجيل والاحتفاظ — لم يُنفذ",
  "Blind spots — not done": "النقاط العمياء — لم يُنفذ",
  "Predicted faults, next ninety days": "الأعطال المتوقعة، التسعون يوماً القادمة",
  "Where the round stands": "موقف الجولة",
  "Every column is one system, every cell one check. Dark is not done — and not done is not the same as passing, which is the whole reason the round is recorded.":
    "كل عمود نظام، وكل خلية فحص. الداكن يعني لم يُنفذ — وعدم التنفيذ ليس نجاحاً، وهذا بالضبط سبب تسجيل الجولة.",
  "Baggage carousels": "سيور استلام الأمتعة",
  "RECORD A BREAKDOWN": "تسجيل عطل",
  UNIT: "الوحدة",
  WHERE: "الموقع",
  LOST: "المفقود",
  "BELT LIFE": "عمر السير",
  "LAST FAULT": "آخر عطل",
  Departures: "المغادرة",
  "Jam and blockage": "انحشار وانسداد",
  "Tracking and misalignment": "انحراف ومحاذاة",
  "Belt tear or splice failure": "تمزق السير أو فشل الوصلة",
  "Photocell or sensor": "خلية ضوئية أو حساس",
  Arrivals: "القدوم",
  "Bearing or roller": "محمل أو بكرة",
  "Transfer line": "خط التحويل",
  Transfer: "التحويل",
  Sorter: "جهاز الفرز",
  Sortation: "الفرز",
  "Out of gauge line": "خط الأمتعة غير القياسية",
  "Availability and belt life": "التوفر وعمر السير",
  "Where the downtime goes": "أين يذهب وقت التوقف",
  "What is expected to stop, and which part": "ما المتوقع أن يتوقف، وأي جزء",
  "RAISE WORK": "إنشاء عمل",
  "nothing outstanding, rate from the book and its own history": "لا شيء معلق، المعدل من الدليل ومن سجله الخاص",
  "Incident reports · facilities": "بلاغات الحوادث · المرافق",
  "Aerodrome documents and forms": "وثائق المطار ونماذجه",
  "Search title, reference or owner": "ابحث بالعنوان أو المرجع أو المالك",
  "ADD ENTRY": "إضافة سجل",
  ID: "المعرّف",
  REV: "المراجعة",
  HELD: "محفوظ",
  Airport: "المطار",
  "Electrical and mechanical utilities": "المرافق الكهربائية والميكانيكية",
  AWAITED: "بانتظار الاستلام",
  "Aerodrome manual": "دليل المطار",
  "NOT SUPPLIED": "غير مُقدَّم",
  "Aerodrome certificate": "شهادة المطار",
  "Safety management system manual": "دليل نظام إدارة السلامة",
  "Aerodrome safety": "سلامة المطار",
  "Aerodrome security programme": "برنامج أمن المطار",
  "Security affairs": "الشؤون الأمنية",
  "Aerodrome emergency plan": "خطة الطوارئ في المطار",
  "Low visibility procedures": "إجراءات انخفاض مدى الرؤية",
  "Runway incursion prevention plan": "خطة منع توغلات المدرج",
  "Snow, sand and adverse weather plan": "خطة الثلوج والرمال والطقس السيئ",
  "Disabled aircraft removal plan": "خطة إزالة الطائرات المعطلة",
  "GACA aerodrome inspection guidance": "إرشادات الهيئة العامة للطيران المدني لفحص المطارات",
  "Capital plan — current year": "الخطة الرأسمالية — العام الحالي",
  Finance: "المالية",
  "Five year capital programme": "البرنامج الرأسمالي لخمس سنوات",
  "Operating budget — current year": "ميزانية التشغيل — العام الحالي",
  "Maintenance contract schedule": "جدول عقود الصيانة",
  Procurement: "المشتريات",
  "Method statement — rubber removal": "بيان الطريقة — إزالة المطاط",
  "Statutory lift and escalator certificates": "الشهادات النظامية للمصاعد والسلالم المتحركة",
  "Fire certificate — terminal": "شهادة الحريق — مبنى الركاب",
  "What the airport should hold": "ما يجب أن يحتفظ به المطار",
  "Blank forms": "نماذج فارغة",
  "Printable versions of the checklists this system runs, for use where a tablet cannot go.":
    "نسخ قابلة للطباعة من قوائم الفحص التي يشغّلها هذا النظام، للاستخدام حيث لا يصل الجهاز اللوحي.",
  "AIRFIELD CHECKLIST": "قائمة فحص الجانب الجوي",
  "TERMINAL CHECKLIST": "قائمة فحص مبنى الركاب",
  "LANDSIDE CHECKLIST": "قائمة فحص الجانب الأرضي",
  "BUILDING CHECKLIST": "قائمة فحص المباني",
  "Visual Analytics": "التحليلات المرئية",
  "Maintenance Reporting": "تقارير الصيانة",
  "photographs and clips of a surface, measured": "صور ومقاطع لسطح، مُقاسة",
  "photographs and short clips of a surface, measured in this page — nothing is uploaded, and it works with no network at all":
    "صور ومقاطع قصيرة لسطح، تُقاس في هذه الصفحة — لا يُرفع شيء، وتعمل دون أي اتصال بالشبكة",
  "nothing loaded — add photographs or a short clip of the surface":
    "لم يُحمَّل شيء — أضف صوراً أو مقطعاً قصيراً للسطح",
  "ADD MEDIA": "إضافة وسائط",
  REPORT: "التقرير",
  "HOW IT READS": "طريقة القراءة",
  "Drop photographs or a short clip here": "أفلت الصور أو مقطعاً قصيراً هنا",
  "ADD PHOTOS OR VIDEO": "إضافة صور أو فيديو",
  "Everything is measured in this page — no image is uploaded anywhere, and it works with no network at all.":
    "كل شيء يُقاس في هذه الصفحة — لا تُرفع أي صورة إلى أي مكان، وتعمل دون أي اتصال بالشبكة.",
  "SCALE — MILLIMETRES PER PIXEL": "المقياس — مليمتر لكل بكسل",
  "not stated": "غير محدد",
  "up and down the frame": "من أعلى الإطار إلى أسفله",
  "across the frame": "عرضياً عبر الإطار",
  "Set for this batch": "مضبوط لهذه الدفعة",
  Scale: "المقياس",
  "not set": "غير مضبوط",
  "Pavement direction": "اتجاه الرصف",
  "Vision model": "نموذج الرؤية",
  "Without a scale, sizes stay in pixels and no severity band is given.":
    "دون مقياس تبقى الأحجام بالبكسل ولا يُحدَّد نطاق للخطورة.",
  Loaded: "محمّل",
  "Nothing loaded.": "لم يُحمَّل شيء.",
  "Nothing has been added yet. Open ADD MEDIA.": "لم يُضف شيء بعد. افتح إضافة وسائط.",
  "Nothing analysed yet.": "لم يُحلَّل شيء بعد.",
  "How to read what this says": "كيف تقرأ النتائج",
  "It measures; it does not recognise.": "يقيس؛ ولا يتعرّف.",
  "Why that distinction matters.": "لماذا يهم هذا التمييز.",
  "What it will get wrong.": "ما الذي سيخطئ فيه.",
  "Clips.": "المقاطع.",
  "Nothing leaves this page.": "لا شيء يغادر هذه الصفحة.",
  CLASSIFIED: "مصنّف",
  CLEANED: "منقّى",
  "PAVER airfield distress identification manuals": "أدلة PAVER لتحديد عيوب رصف الجانب الجوي",
  "Airfield bands, not road bands.": "نطاقات الجانب الجوي، لا نطاقات الطرق.",
  "What is in the frame that is not the pavement": "ما في الإطار وليس من الرصف",
  "Loose objects — FOD.": "الأجسام السائبة — FOD.",
  "Vegetation.": "الغطاء النباتي.",
  "Buildings are not flagged.": "المباني لا يُشار إليها.",
  "Vertical signage is flagged.": "اللوحات الإرشادية الرأسية يُشار إليها.",
  "What a photograph cannot settle, it says so.": "ما لا تستطيع الصورة حسمه، تقول ذلك.",
  "every job the airport is maintaining — raised, due and expected": "كل عمل يصونه المطار — مُنشأ ومستحق ومتوقع",
  "LIVE MAP": "الخريطة المباشرة",
  "Open now": "مفتوح الآن",
  "Past response time": "تجاوز زمن الاستجابة",
  "Mean time to repair": "متوسط زمن الإصلاح",
  "Closed with a note": "مغلق مع ملاحظة",
  "Independently verified": "تم التحقق منه باستقلالية",
  "Raised against something that has failed or been found": "أُنشئ لشيء تعطّل أو عُثر عليه",
  "Due from a programme cycle — the date is a commitment": "مستحق من دورة برنامج — التاريخ التزام",
  PREDICTED: "متوقع",
  "ANY STATE": "أي حالة",
  "ALL AREAS": "كل المناطق",
  AIRSIDE: "الجانب الجوي",
};
export default ar;
